import { format } from 'date-fns';
import { getDateFnsLocale } from '../../utils/attendanceUtils';

export const flattenDepartments = (nodes = [], acc = []) => {
  nodes.forEach((node) => {
    acc.push({ id: node.id, name: node.name, level: node.level || 0 });
    if (node.enfants && node.enfants.length) {
      flattenDepartments(node.enfants, acc);
    }
  });
  return acc;
};

export const formatDateLabel = (dateStr, language) => {
  try {
    const label = format(new Date(dateStr), 'EEE dd/MM/yyyy', { locale: getDateFnsLocale(language) });
    return label.replace(/\.$/, '');
  } catch {
    return dateStr;
  }
};

export const formatTimeLabel = (timestamp) => {
  try {
    return format(new Date(timestamp), 'HH:mm:ss');
  } catch {
    return timestamp;
  }
};

export const isHoliday = (dateStr, holidays) => {
  if (!dateStr || !holidays || holidays.length === 0) return null;
  const checkDate = format(new Date(dateStr), 'yyyy-MM-dd');
  return holidays.find((holiday) => format(new Date(holiday.date), 'yyyy-MM-dd') === checkDate);
};

export const buildParams = ({ currentPage, dateRange, selectedDepartment, rowsPerPage, filterType, searchTerm, selectedEmployees }) => {
  const params = new URLSearchParams();
  params.set('skip', (currentPage - 1) * rowsPerPage);
  params.set('limit', rowsPerPage);
  if (dateRange.start) params.set('start_date', `${dateRange.start}T00:00:00`);
  if (dateRange.end) params.set('end_date', `${dateRange.end}T23:59:59`);
  if (selectedDepartment) params.set('department_id', selectedDepartment);
  if (filterType && filterType !== 'all') params.set('punch_type', filterType);
  if (searchTerm?.trim()) params.set('search', searchTerm.trim());
  if (selectedEmployees?.length) {
    selectedEmployees.forEach((employeeId) => params.append('employee_ids', employeeId));
  }
  return params;
};
